<template>
  <div :class="'card ' + (props.selected ? 'border-primary' : 'border-secondary')">
    <div class="card-body">
      <p class="card-title text-center mb-3">{{ props.title }}</p>
      <div class="d-flex justify-content-center m-2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  selected?: boolean;
}

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.border-secondary {
  border-color: #cbcbcb !important;
}
</style>
